import { Hero } from "@/components/site/Hero";
import { HowItWorks } from "@/components/site/HowItWorks";
import { Features } from "@/components/site/Features";
import { Manifesto } from "@/components/site/Manifesto";
import { Ribbon } from "@/components/site/Ribbon";
import { Pricing } from "@/components/site/Pricing";
import { WhoFor } from "@/components/site/WhoFor";
import { BookDemo } from "@/components/site/BookDemo";
import { LeadPopup } from "@/components/site/LeadPopup";

export default function Landing() {
  return (
    <>
      <Hero />
      <HowItWorks />
      <Features />
      <Manifesto />
      <Ribbon />
      <Pricing />
      <WhoFor />
      <BookDemo />
      <LeadPopup context="site" />
    </>
  );
}
